import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bf58138&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5bf58138&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf58138",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomepageWelcome: require('/opt/build/repo/components/HomepageWelcome.vue').default,ProductExerptList: require('/opt/build/repo/components/ProductExerptList.vue').default,AppButton: require('/opt/build/repo/components/AppButton.vue').default,IHeart: require('/opt/build/repo/components/svg/Heart.vue').default,AirtableImage: require('/opt/build/repo/components/AirtableImage.vue').default,AppImage: require('/opt/build/repo/components/AppImage.vue').default,ILikeInsta: require('/opt/build/repo/components/svg/LikeInsta.vue').default,ILogo: require('/opt/build/repo/components/svg/Logo.vue').default,ILogoWordFlat: require('/opt/build/repo/components/svg/LogoWordFlat.vue').default,CategoryGrid: require('/opt/build/repo/components/CategoryGrid.vue').default})
